// eslint-disable-next-line no-shadow
enum PermissionType {
  ViewWebClock = '9ac0a519-1ae0-4c7c-9960-739505b584ce',
}

export default PermissionType;
